import { useMutation } from '@tanstack/react-query';

import { ImportPreview, ImportResult, ImportType, importApi } from '@/services/api/import/import';

export function useImportPreviewMutation() {
  return useMutation<ImportPreview, Error, { type: ImportType; file: File }>({
    mutationFn: ({ type, file }) => importApi.preview(type, file),
  });
}

export function useImportCommitMutation() {
  return useMutation<ImportResult, Error, { type: ImportType; file: File; invite?: boolean }>({
    mutationFn: ({ type, file, invite }) => importApi.commit(type, file, invite),
  });
}
